import { useDispatch } from "react-redux";
import { toast } from "react-toastify";

import {
  ArchiveCustomEventRequestBodyType,
  ArchiveCustomEventResponseBodyType,
} from "@intelligems/ig-types";
import { combinedCustomEventsKeys, customEventsKeys } from "@src/api/queryKeys";
import { ApiRequest } from "@src/api/types/api";
import { setArchivingEventId } from "@src/store/slices/customEvents";
import { setIgnoreUpdateDetected } from "@src/store/slices/global";
import { useMutation, useQueryClient } from "@tanstack/react-query";

import { api } from "../api";

const archiveCustomEvent = async (
  data: ApiRequest<ArchiveCustomEventRequestBodyType>
): Promise<ArchiveCustomEventResponseBodyType> => {
  const resp = await api.patch<ArchiveCustomEventResponseBodyType>(
    `/v2/custom-events/${data.body.customEventId}/archive`,
    { customEventId: data.body.customEventId }
  );
  return resp.data;
};

export const useArchiveCustomEvent = () => {
  const queryClient = useQueryClient();
  const dispatch = useDispatch();

  return useMutation({
    mutationKey: ["archiveCustomEvent"],
    mutationFn: async (data: ApiRequest<ArchiveCustomEventRequestBodyType>) =>
      archiveCustomEvent(data),
    onMutate: () => {
      dispatch(setIgnoreUpdateDetected(true));
    },
    onSuccess: async (data, payload) => {
      await queryClient.invalidateQueries({
        queryKey: combinedCustomEventsKeys.all,
      });
      void queryClient.invalidateQueries({
        queryKey: customEventsKeys.all,
      });
      dispatch(setArchivingEventId({ id: "" }));
      toast.success(`${data.customEvent.name} Archived`);
    },
  });
};
